var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-banner'),_c('color-currents-banner'),(!_vm.isFetching)?_c('main',{attrs:{"id":"main","role":"main"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_c('app-loading'),_c('app-tail'),[_c('vue-headful',{attrs:{"title":_vm.documentTitle}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }